/***
 * 拆分核心业务请求 和 非核心业务请求
 * 核心业务请求在Service1(index)里 非核心业务请求在Service2里
 * 2022-06-20 CHP
 */
import axios from 'axios'
// import store from '@/store/store'
import router from '@/router'
import config from '../../static/config/config'

// 2021/11/23 WXJ   增加计数器
let requestNumber = 0

const request = (method, url, data, noLoading) => {
  if (!noLoading) {
    if (document.getElementById('loading').innerHTML.trim() === '') {
      var imageHtml = '<div><img src="static/images/loading.gif" alt=""></div>'
      document.getElementById('loading').innerHTML = imageHtml
    }
    document.getElementById('loading').style.display = 'block'
  }
  const send = axios.create({baseURL: config.baseURL})
  send.interceptors.request.use(config => {
    // 2021/11/23 WXJ   增加计数器
    if (!noLoading) {
      requestNumber++
    }

    // console.log('requestNumber++：' + requestNumber)

    const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).Token : ''
    if (token) {
      config.headers.Authorization = token
    }
    return config
  }, err => {
    return Promise.reject(err)
  })

  send.interceptors.response.use(response => {
    // 2021/11/23 WXJ   增加计数器
    if (!noLoading) {
      requestNumber--
    }
    // console.log('requestNumber--：' + requestNumber)
    // store.commit('toggleLoading', false)
    // 2021/11/23 WXJ   根据计数器显示
    if (requestNumber <= 0) {
      document.getElementById('loading').style.display = 'none'
    }
    return response.data
  }, error => {
    // store.commit('toggleLoading', false)
    // 2021/11/23 WXJ   根据计数器显示
    if (!noLoading) {
      requestNumber--
    }
    // console.log('error requestNumber--：' + requestNumber)
    if (requestNumber <= 0) {
      document.getElementById('loading').style.display = 'none'
    }
    // 2021-06-19 CHEN PU If err.response is null, here will throw exception
    if (error.response && error.response.status === 401) {
      router.push('/Login')
    }
    return Promise.reject(error.response) // 返回接口返回的错误信息
  })

  return send({method, url, data})
}

export default request



// WEBPACK FOOTER //
// ./src/service/index.js